import { forwardRef } from 'react';
import { StyledLi } from './styled';

const Li = forwardRef((props, ref) => <StyledLi ref={ref} {...props} />);

export default Li;
